import React from 'react';
import './Faculties.css';
// import teacher1 from '../../assets/images/teacher1.jpg';
// import teacher2 from '../../assets/images/teacher2.jpg';
// import teacher3 from '../../assets/images/teacher3.jpg';
// import teacher4 from '../../assets/images/teacher4.jpg';

const Faculties = () => {
  const facultyData = [
    {
      name: 'Sir Ahmad Khan',
      position: 'Principal & Senior Lecturer',
      desc: 'Expert in Mathematics and leadership with over 15 years of teaching experience.',
    //   img: teacher1,
    },
    {
      name: 'Miss Sara Fatima',
      position: 'Science Department Head',
      desc: 'Passionate about physics and chemistry, fostering curiosity among young minds.',
    //   img: teacher2,
    },
    {
      name: 'Sir Bilal Ali',
      position: 'Computer Science Lecturer',
      desc: 'Full-stack developer and software trainer with a focus on practical learning.',
    //   img: teacher3,
    },
    {
      name: 'Miss Zainab Abbas',
      position: 'English Language Instructor',
      desc: 'Dedicated to improving communication and writing skills of students.',
    //   img: teacher4,
    },
  ];

  return (
    <section className="faculties-section">
      <h1 className="faculties-title">Meet Our Faculty</h1>
      <p className="faculties-subtitle">
        Our teachers are dedicated professionals who inspire, guide, and shape the future of our students.
      </p>

      <div className="faculty-grid">
        {facultyData.map((faculty, index) => (
          <div className="faculty-card" key={index}>
            <div className="faculty-image">
              <img src={faculty.img} alt={faculty.name} />
            </div>
            <div className="faculty-info">
              <h3>{faculty.name}</h3>
              <h4>{faculty.position}</h4>
              <p>{faculty.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faculties;
